export default __webpack_public_path__ + "static/media/home.85de5680.svg";